import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, DestroyRef } from '@angular/core';
import { Permission } from 'src/app/models/principal/permission';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from '../../services/util/sidenav.service';
import { BookmarksComponent } from 'src/app/layout/toolbar/bookmarks/bookmarks.component';
import { NotificationsComponent } from 'src/app/layout/toolbar/notifications/notifications.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from 'src/app/models/constants';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { SupportResourcesComponent } from 'src/app/layout/toolbar/support-resources/support-resources.component';
import { TenantBookmarkComponent } from './../../layout/toolbar/tenant-bookmark/tenant-bookmark.component';
import { AboutPortalComponent } from 'src/app/layout/toolbar/about-portal/about-portal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeatureFlagsManagerService } from 'src/app/services/util/feature-flags-manager.service';
import { TenantSelectDialogComponent } from '../tenant-select-dialog/tenant-select-dialog.component';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent  implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  hasSecondaryRegion: boolean;
  utcTime: string = '';
  localTime: string = '';
  localTimezoneAbbr: string = '';
  private clockInterval: ReturnType<typeof setInterval>;
  private featureFlagsManagerService = inject(FeatureFlagsManagerService);
  private tenantDialogRef?: MatDialogRef<TenantSelectDialogComponent>;

  @Input() set tenants(tenantsList) {
     if (!tenantsList) {           // API hasn't responded yet
    this.tenantsList = undefined;
    this.filteredTenants = undefined;
    return;
  }
    this.tenantsList = tenantsList.filter(item => item?.status !== 'Obsolete');
    this.filteredTenants = this.tenantsList;

    if (this.tenantDialogRef) {
      this.tenantDialogRef.componentInstance.data.tenants = this.tenantsList;
    }
  }

  @Input() selectedTenantId: any;
  @Output() selectionChanged = new EventEmitter();
  Constants = Constants;

  tenantsList: any;
  tenant: string;
  hasMySandboxPermission: boolean;
  permissionsMap: { [key: string]: boolean };
  Permission = Permission;
  tenantGroup: FormGroup;
  switchTenant: boolean;
  regionResponse: any;
  searchValue: any;
  filteredTenants: any;
  activeFilter: 'all' | 'foundation' | 'external' = 'all';

  constructor(private authService: AuthService, public toastrService: CustomToastrService, public sidenavService: SidenavService, private fb: FormBuilder, public router: Router, public tenantService: TenantService, private matDialog: MatDialog
  ) {

  }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.updateClock();
    this.clockInterval = setInterval(() => this.updateClock(), 1000);
    if(this.selectedTenantId){
      this.tenantApi();
      }
    this.tenantGroup = this.fb.group({
      tenantDropdown: [this.selectedTenantId ? this.selectedTenantId : undefined],
    });
    this.featureFlagsManagerService.loadFeatureFlags(this.selectedTenantId);
  }

  ngOnDestroy(): void {
    clearInterval(this.clockInterval);
  }

  private updateClock(): void {
    const now = new Date();
    this.utcTime = now.toLocaleTimeString('en-GB', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    this.localTime = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    const tzFullName = now.toTimeString().match(/\(([^)]+)\)/)?.[1] || '';
    this.localTimezoneAbbr = tzFullName ? tzFullName.split(' ').map((w: string) => w[0]).join('') : (Intl.DateTimeFormat('en-US', { timeZoneName: 'short' }).formatToParts(now).find(p => p.type === 'timeZoneName')?.value || '');
  }

  searchChanged(value): void {
    this.searchValue = value;
    this.applyFilter();
  }

  setFilter(filter: 'all' | 'foundation' | 'external'): void {
    this.activeFilter = filter;
    this.applyFilter();
  }

  private applyFilter(): void {
    let tenants = this.tenantsList;
    if (this.activeFilter === 'foundation') {
      tenants = tenants.filter((tenant: any) => tenant?.origin !== 'external');
    } else if (this.activeFilter === 'external') {
      tenants = tenants.filter((tenant: any) => tenant?.origin === 'external');
    }
    if (this.searchValue) {
      tenants = tenants.filter((item: any) => item?.tenantId?.toLowerCase().includes(this.searchValue.toLowerCase()));
    }
    this.filteredTenants = tenants;
  }

  openHelpAndSupport(): void {
    this.sidenavService.openInRightSidenav(SupportResourcesComponent);
  }

  openAbout(): void {
    this.matDialog.open(AboutPortalComponent, {
      position: { top: 'calc(68px)', right: 'calc(12px)' },
      width: 'calc(min(380px, 100% - 24px))',
      maxHeight: 'calc(100vh - 80px)',
      panelClass: 'about-portal-dialog',
      backdropClass: 'about-portal-backdrop',
      autoFocus: false
    });
  }

  openTenantDialog(): void {    
  this.tenantDialogRef = this.matDialog.open(TenantSelectDialogComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'tenant-dialog-panel',
      autoFocus: false,
      data: { tenants: this.tenantsList, selectedTenantId: this.selectedTenantId }
    });
     this.tenantDialogRef.afterClosed().subscribe((tenantId?: string) => {
    this.tenantDialogRef = undefined;
    if (tenantId && tenantId !== this.selectedTenantId) {
      this.getSelectedTenant(tenantId);
    }
  });
}

  selectedTenant(event): void {
    this.tenantApi();
    this.selectionChanged.emit(event);
    this.tenantGroup = this.fb.group({
      tenantDropdown: [this.selectedTenantId ? this.selectedTenantId : event],
    });
  }

  onSwitchClick(): void {
    this.switchTenant = false;
    this.router.navigate(['/',this.authService.principal.provider]);
    localStorage.setItem('switchTenant', JSON.stringify(this.switchTenant));
  }

  bookmarksClick(): void {
    if (this.switchTenant) {
      this.sidenavService.openInRightSidenav(BookmarksComponent);
    } else {
      this.sidenavService.openInRightSidenav(TenantBookmarkComponent);
    }
  }

  openNotifications(): void {
    this.sidenavService.openInRightSidenav(NotificationsComponent);
  }

  getSelectedTenant(event): void {
    const getTenantSource = this.tenantsList?.filter(item => item?.tenantId === event);
    this.tenantService.setTenantSource(getTenantSource?.[0] ?? null);
    this.selectedTenantId = event;
    this.tenantService.setTenant(event);
    this.selectionChanged.emit(event);
      this.tenantApi();
      localStorage.removeItem('filteredJumpboxStatus');
      localStorage.removeItem('filteredJumpboxDatazone');
      localStorage.removeItem('filteredJumpboxDate');
      localStorage.removeItem('filteredJumpboxStartDate');
      localStorage.removeItem('filteredJumpboxEndDate');
      localStorage.removeItem('filteredJumpboxModifiedStartDate');
      localStorage.removeItem('filteredJumpboxModifiedEndDate');
      localStorage.removeItem('filteredEndpointsStatus');
      localStorage.removeItem('console-pecols');
      localStorage.removeItem('console-jbcols');
      localStorage.removeItem('console-schedulecols');
      localStorage.removeItem('scheduleInstance');
      localStorage.removeItem('console-cloudcols');
      localStorage.removeItem('console-enckeycols');
      localStorage.removeItem('console-auditcols');
      localStorage.removeItem('console-custImages');
      this.featureFlagsManagerService.loadFeatureFlags(this.selectedTenantId);
  }

    tenantApi(): void {
      this.tenantService.getTenants(this.selectedTenantId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response: any)=> {
          if (response) {
            this.regionResponse = response[0];
            this.tenantService.setTenantSource(this.regionResponse ?? null);
            if(this.regionResponse?.parameters?.hasSecondaryRegion && (this.regionResponse?.parameters?.hasSecondaryRegion === 'true' || this.regionResponse?.parameters?.hasSecondaryRegion === true)) {
              this.hasSecondaryRegion = true;
            } else if(!this.regionResponse?.parameters?.hasSecondaryRegion) {
              this.hasSecondaryRegion = true;
            } else {
              this.hasSecondaryRegion = false;
            }
          }
        },
          (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
          });
    }


    resetFilter(): void {
      this.searchValue = undefined;
      this.activeFilter = 'all';
      this.filteredTenants = this.tenantsList;
    }

    dropdownClose(): void {
      if (this.filteredTenants?.length === 0) {
        this.filteredTenants = this.tenantsList;
      }
    }

    getTenant() {
      return this.tenantsList?.find(t => t.tenantId === this.selectedTenantId);
    }

  }
